/*global
    jQuery
*/
(function ($) {
    var triggerCompleteContract = function(appId) {
        if (typeof appId == 'undefined') {
            return false;
        }
        var application_id = appId;
        var $target = $('a.complete-contract[data-appid="'+application_id+'"]');
        if (typeof $target !== 'undefined' && $target.length > 0 ) {
            if ($target.parents('div.single-application').hasClass('unseen')) {
                return false;
            }

            if (typeof application_id !== 'undefined') {
                getDocument(application_id);
            } else {
                return false;
            }
        }
    };

    var getDocument = function(application_id) {
        $.get('/api/contract/'+application_id, function(response) {
            if (typeof response !== 'undefined' && typeof response.status !== 'undefined' && response.status == 'success') {
                initHelloSign(application_id, response.client_id, response.sign_url, response.redirect_url);
            } else if (typeof response !== 'undefined' && typeof response.status !== 'undefined' && response.status == 'already_signed') {
                $remodalInstance = $('div.already-signed-modal').remodal();
                $(document).on('closed', '.remodal', function (e) {
                    if ( e.reason == undefined || e.reason == false || e.reason !== 'confirmation') {
                    }
                });
                $remodalInstance.open();
            }
        });
    };

    var initHelloSign = function(application_id, client_id, sign_url, redirect_url) {
        const client = new HelloSign({ clientId: client_id });
        client.open(sign_url, {
            allowCancel: true,
        });

        client.on(HelloSign.events.SIGN, function () {
            document.location = redirect_url;
        });
    };

    var dismissContractModal = function() {
        var application_id = $('div.contract-confirm-modal').find('input[name="application-id"]').val('');
        $('div.contract-confirm-modal').hide();
    }

    var confirmContractModal = function () {
        var application_id = $('div.contract-confirm-modal').find('input[name="application-id"]').val();
        // After getting application_id, clear hidden input in modal
        $('div.contract-confirm-modal').find('input[name="application-id"]').val('');
        triggerCompleteContract(application_id);
    }

    var showContractModal = function(e) {
        e.preventDefault();
        var $target = $(e.target),
            application_id = $target.data('appid'),
            $confirmModal = $('div.contract-confirm-modal');
        if ($target.parents('div.single-application').hasClass('unseen') || $target.hasClass('disabled')) {
            return false;
        } else {
            if (typeof application_id !== 'undefined') {
                $confirmModal.find('input[name="application-id"]').val(application_id);
                $remodalInstance = $confirmModal.remodal();
                $(document).on('confirmation', '.remodal', function() {
                    confirmContractModal();
                });
                $(document).on('closed', '.remodal', function (e) {
                    if ( e.reason == undefined || e.reason == false || e.reason !== 'confirmation') {
                    }
                });
                $remodalInstance.open();
            }
        }
    }

    $('a.complete-contract').on('click', showContractModal);

    var recordContactAttempt = function(e) {
        var $target = $(e.target),
            application_id = $target.data('appid');
        if ($target.hasClass('disabled')) {
            e.preventDefault();
            return false;
        }
        $.get('/mypets/owner-clicked-contact-link/' + application_id, function(response){
            if (typeof response !== 'undefined' && typeof response.status !== 'undefined' && response.status == 'success') {
                $target.parents('div.form-control').find('a.complete-contract').removeClass('disabled');
                $target.addClass('previous-app-step');
            }
        });
        $.get('/mypets/owner-contacted-using-method/' + application_id + '/email', function(response) {
            console.log(response);
        });     
    }

    $('a.contact-adopter-link').on('click', recordContactAttempt);

    var viewApplicationClicked = function(e) {
        var $target = $(e.target);
        $target.parents('div.form-control').find('a.contact-adopter-link').removeClass('disabled');
        $target.addClass('previous-app-step');
    }

    // Listen for potential clicks in other tab of browser to the Contact button on application review page
    if (typeof localStorage !== 'undefined') {
        var receiveContactClickedEvent = function(e) {
            if (typeof e.originalEvent !== 'undefined' && typeof e.originalEvent.key !== 'undefined' && e.originalEvent.key == 'app_contact_clicked' && e.originalEvent.newValue !== null) {
                var message = JSON.parse(e.originalEvent.newValue);
                if (typeof message == 'undefined' || typeof message.appId == 'undefined' || message.appId == '') {
                    return;
                }

                var $contactOwnerLink = $('a.application-contact-link[data-appid="' + message.appId + '"]');
                var $startContractLink = $('a.complete-contract[data-appid="' + message.appId + '"]');

                // Mark contact owner link as previously completed
                $contactOwnerLink.addClass('previous-app-step');

                // Enable start contract link
                $startContractLink.removeClass('disabled');
            }
        }

        $(window).on('storage', receiveContactClickedEvent);
    }

    $('a.view-application-link').on('click', viewApplicationClicked);
}(jQuery));
